module.exports = __webpack_public_path__ + "media/npc_dota_hero_centaur.5cb9c428.webm";